import React from 'react';
import './MobileMenuBottom.scss';
import Home from './../../assets/svgs/homeLW.svg';
import Search from './../../assets/svgs/searchLW.svg';
import List from './../../assets/svgs/list-textLW.svg';
import User from './../../assets/svgs/userLW.svg';

const MobileMenuBottom = () => {
  return (
    <div className="footer-mobile-nav">
      <div className="menu-bottom">
        <div className="home-icon">
          <img src={Home} alt="Home" />
        </div>
        <div className="search-icon">
          <img src={Search} alt="Search" />
        </div>
        <div className="list-icons">
          <img src={List} alt="List" />
        </div>
        <div className="user-icons">
          <img src={User} alt="User" />
        </div>
      </div>
    </div>
  );
};

export default MobileMenuBottom;
